import type { ComponentProps } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'

export const AppWrapper = ({
	className,
	children,
	...props
}: ComponentProps<'main'>) => (
	<main
		{...props}
		className={cn('flex flex-col', className)}
	>
		{children}
	</main>
)
